import React from "react";
import { Pagination } from "react-bootstrap";

const calcStartEndIndexes = (totalPages, number) => {
  let startIndex = 0;
  let endIndex = 0;

  if (totalPages < 6) {
    endIndex = totalPages - 1;
  } else {
    startIndex = number - 2;
    endIndex = number + 2;
    if (startIndex < 0) {
      endIndex -= startIndex;
      startIndex = 0;
    } else if (endIndex >= totalPages) {
      startIndex = startIndex - (endIndex - totalPages + 1);
      endIndex = totalPages - 1;
    }
  }
  return { startIndex, endIndex };
};

const createPagination = (pageInfo, onPageNumberClick) => {
  if (!pageInfo) return undefined;

  const { totalPages, number } = pageInfo;
  let paginationItems = [];

  const { startIndex, endIndex } = calcStartEndIndexes(totalPages, number);

  if (startIndex > 0) {
    paginationItems.push(
      <Pagination.First
        key="first"
        onClick={() => {
          const first = {
            target: {
              id: "0"
            }
          };
          onPageNumberClick(first);
        }}
      />
    );
  }
  if (number > 0) {
    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => {
          const first = {
            target: {
              id: number - 1
            }
          };
          onPageNumberClick(first);
        }}
      />
    );
  }
  for (let index = startIndex; index <= endIndex; index++) {
    paginationItems.push(
      <Pagination.Item
        key={index.toString()}
        id={index}
        active={number === index}
        onClick={onPageNumberClick}
      >
        {index + 1}
      </Pagination.Item>
    );
  }
  if (number < totalPages - 1) {
    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => {
          const first = {
            target: {
              id: number + 1
            }
          };
          onPageNumberClick(first);
        }}
      />
    );
  }
  if (endIndex < totalPages - 1) {
    paginationItems.push(
      <Pagination.Last
        key="last"
        onClick={() => {
          const first = {
            target: {
              id: totalPages - 1
            }
          };
          onPageNumberClick(first);
        }}
      />
    );
  }

  return paginationItems;
};

const GenericPagination = props => {
  return (
    <div className="tree-pagination">
      <Pagination size={props.size}>
        {createPagination(props.pageInfo, props.onPageNumberClick)}
      </Pagination>
    </div>
  );
};

export default GenericPagination;
